import React from 'react';
import { NavLink, NavLinkMyAccount } from '@snsw/react-global-nav';
import { GlobalNavConfig } from './GlobalNavConfig';
import { IconSignOut } from '@snsw-gel/react';

export const GlobalNavLinks = (props: { appConfig: GlobalNavConfig; }) => {
    const configs: GlobalNavConfig = props.appConfig;
    return (
        <>
            <NavLinkMyAccount
                title='Account'
                url={ configs.globalNavLinksUrl }
            />
            <NavLink
                title='Log out'
                url={ configs.logoutUrl ?? './logout' }
                icon={ <IconSignOut /> }
            />
        </>
    );
};
